import { OkrsModule } from "./okrs.module";

export { UpdateMetricComponent } from "./metrics/components/update-metric/update-metric.component";

// ts-unused-exports:disable-next-line
export const ngModule = OkrsModule;

// ts-unused-exports:disable-next-line
export const ng1ModuleFn = (): Promise<string> => import(/* webpackMode: "eager" */ "@gtmhub/okrs/okrs.module").then((x) => x.default);
